import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import Layout from '../../components/Layout'
import SEO from '../../components/SEO'
import Breadcrumbs from '../../components/Breadcrumbs'
import MicroFrontendContainer from '../../components/MicroFrontend/MicroFrontendContainer'

const CertificatResidencePage: React.FC = () => {
  const intl = useIntl()
  const currentLanguage = intl.locale as 'fr' | 'mg'
  
  const breadcrumbItems = [
    { label: intl.formatMessage({ id: 'nav.home' }), path: '/' },
    { label: intl.formatMessage({ id: 'nav.services' }), path: '/services' },
    { 
      label: intl.formatMessage({ id: 'service.certificat.title' }),
      path: '/services/certificat-residence' 
    }
  ]
  
  return (
    <Layout>
      <SEO 
        title={intl.formatMessage({ id: 'service.certificat.title' })}
        description={intl.formatMessage({ id: 'service.certificat.description' })}
      />
      
      <Breadcrumbs items={breadcrumbItems} />
      
      <MicroFrontendContainer
        url={process.env.GATSBY_MICROFRONTEND_URL || 'http://localhost:3001'}
        //url={'https://certificat-residence.app.digital.gov.mg'} // TODO: remove this after testing and use the env variable
        language={currentLanguage}
        onFormSubmit={(data) => {
          console.log('Form submitted:', data)
          // Optional: Track with GTM
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'certificate_form_submit',
              certificateType: 'residence',
              language: currentLanguage
            })
          }
        }}
        onError={(error) => {
          console.error('Micro-frontend error:', error)
        }}
      />
    </Layout>
  )
}

export default CertificatResidencePage

